import axios from 'axios';
import { createAxiosConfig } from '../mockHelper';
import { GetMembershipContent, IGetMembershipContentRequest } from '../contracts';
import LogCannon from '@ace-clublabs/log-cannon';
import { delay } from '../../utils/helpers';
import { MembershipApp } from '@lib/types';

export const GetMembershipContentApi =
  (endpoint: string): GetMembershipContent =>
  async ({ newJoinSessionId }: IGetMembershipContentRequest) => {
    try {
      let queryString = `?newJoinSessionId=${newJoinSessionId}&appName=${MembershipApp.NewJoin}`;
      const constructedEndpoint = `${endpoint}/${queryString}`;
      const response = await axios.get(constructedEndpoint, createAxiosConfig(null, endpoint));
      LogCannon.blast('GetMembershipContentApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
